import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const MotorhomeSVG: React.FunctionComponent<StyledProps> = ({
  width = 20,
  height = 15,
  display = "inline-flex",
  marginX = 0,
  ...props
}) => {
  return (
    <StyledContainer {...props}>
      <svg width="20" height="16" viewBox="0 0 20 16" fill="none">
        <path
          d="M19.4062 8.42819L17.5938 6.58647C17.2188 6.21189 16.6875 6.0246 16.1562 6.0246L13 5.99338V13.4851C13 14.5776 13.6875 15.5765 14.7188 15.8887C16.4062 16.3881 18 15.1395 18 13.4851V12.9857H19C19.5312 12.9857 20 12.5486 20 11.9868V9.83289C20 9.30223 19.7812 8.80278 19.4062 8.42819ZM15.5 14.484C14.9375 14.484 14.5 14.047 14.5 13.4851C14.5 12.9544 14.9375 12.4862 15.5 12.4862C16.0312 12.4862 16.5 12.9544 16.5 13.4851C16.5 14.047 16.0312 14.484 15.5 14.484ZM15 8.99007V7.49172H16.1562C16.2812 7.49172 16.4062 7.55416 16.5 7.6478L17.875 8.99007H15ZM19 3.99559C18.9688 2.34116 17.625 0.998897 16 0.998897H12V0.499448C12 0.249724 11.75 0 11.5 0H7.5C7.21875 0 7 0.249724 7 0.499448V0.998897H2C0.875 0.998897 0 1.90415 0 2.99669V9.17736C0 9.70803 0.1875 10.2075 0.5625 10.5821L3 12.9857V13.3602C3 14.6713 3.9375 15.8575 5.21875 15.9823C6.71875 16.1384 8 14.9522 8 13.4851V12.9857H12V4.99448H18C18.5312 4.99448 19 4.55747 19 3.99559ZM5.5 14.484C4.9375 14.484 4.5 14.047 4.5 13.4851C4.5 12.9544 4.9375 12.4862 5.5 12.4862C6.03125 12.4862 6.5 12.9544 6.5 13.4851C6.5 14.047 6.03125 14.484 5.5 14.484ZM8 6.49283C8 6.77377 7.75 6.99228 7.5 6.99228H3.5C3.21875 6.99228 3 6.77377 3 6.49283V4.49504C3 4.24531 3.21875 3.99559 3.5 3.99559H7.5C7.75 3.99559 8 4.24531 8 4.49504V6.49283Z"
          fill="#070B16"
        />
      </svg>
    </StyledContainer>
  );
};

export default MotorhomeSVG;
